import { render, staticRenderFns } from "./BannerMessage.vue?vue&type=template&id=3a754f92&"
import script from "./BannerMessage.vue?vue&type=script&lang=ts&"
export * from "./BannerMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports